export const moveItemFailedNotification = "cFqdk";
export default {moveItemFailedNotification};